import type { TaxonomyKind } from "@recipevault/shared";

/**
 * Per-kind chip color presets. Same shape across surfaces (recipe view, editor)
 * so a user reads "amber = category, sky = cuisine, violet = diet, emerald = tag"
 * once and the mapping holds everywhere.
 *
 * Calibrated for the dark theme: ~25% saturated background with a ~60% border
 * and a high-contrast foreground. All four pairs clear AA on `--background`.
 */
export const KIND_CHIP_CLASS: Record<TaxonomyKind, string> = {
  tag: "bg-emerald-700/25 border-emerald-600/60 text-emerald-200",
  category: "bg-amber-700/30 border-amber-600/60 text-amber-100",
  cuisine: "bg-sky-700/25 border-sky-600/60 text-sky-200",
  diet: "bg-violet-700/25 border-violet-600/60 text-violet-200",
};
